export const actions = {
  ADD_PAYMENT: 'ADD_PAYMENT',
  DELETE_PAYMENT: 'DELETE_PAYMENT',
  DELETE_CYCLE: 'DELETE_CYCLE',
  PAY_PAYMENT: 'PAY_PAYMENT',
  EDIT_PAYMENT: 'EDIT_PAYMENT',
};
